<template>
  <div>
    <div v-if="isLoading === false">
      <div class="tw-flex tw-mb-3 tw-justify-end">
        <div class="tw-text-sm tw-mr-2 tw-my-auto tw-text-gray-800 tw-cursor-pointer">Show deleted prescriptions</div>
        <base-toggle v-model="showDeleted" />
      </div>
      <base-card v-for="prescription in prescriptions" :key="prescription.id" class="tw-mb-4">
        <business-member-prescription
          :prescription="prescription"
          :user-id="userId"
          :business-id="businessId"
          :rxItems="rxItems"
          :businessUsers="businessUsers"
          @updated="loadPrescriptions"
          @show-invite-modal="$refs.inviteToPlanModal.show($event)"
          @show-create-modal="$refs.createPlanModal.show($event)"
          @update-supervising-prescriber="handleUpdateSupervisingPrescriber"
        />
      </base-card>
    </div>
    <base-card v-if="isLoading">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-flex-col tw-flex-grow">
          <base-skeleton-loader class="tw-h-5 tw-w-32 tw-mb-2" />
          <base-skeleton-loader class="tw-h-4 tw-w-1/2" />
        </div>
        <base-icon>
          <more-vertical-icon class="tw-w-6 tw-h-6" />
        </base-icon>
      </div>
      <div class="tw-flex tw-justify-between tw-mt-9">
        <div class="tw-flex-grow tw-pr-4">
          <base-skeleton-loader class="tw-h-8 tw-w-full " />
        </div>
        <div class="tw-flex tw-space-x-4 tw-my-auto">
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full " />
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full" />
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-mt-8">
        <div class="tw-flex-grow tw-pr-4">
          <base-skeleton-loader class="tw-h-8 tw-w-full " />
        </div>
        <div class="tw-flex tw-space-x-4 tw-my-auto">
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full " />
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full" />
        </div>
      </div>
      <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
      <div class="tw-w-full tw-border-gray-200 tw-border-t tw-mt-4"></div>
      <div class="tw-flex tw-justify-between">
        <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
        <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
      </div>
    </base-card>
    <business-member-prescription-create-plan :business-id="businessId" :user-id="userId" ref="createPlanModal" @updated="goToMemberPlans()" />
    <business-member-prescription-invite-to-plan :business-id="businessId" :user-id="userId" ref="inviteToPlanModal" />
  </div>
</template>

<script>
import BusinessMemberPrescription from "@/views/business/member/prescriptions/components/BusinessMemberPrescription";
import BusinessMemberPrescriptionCreatePlan from "@/views/business/member/prescriptions/components/BusinessMemberPrescriptionCreatePlan";
import BusinessMemberPrescriptionInviteToPlan from "@/views/business/member/prescriptions/components/BusinessMemberPrescriptionInviteToPlan";
import { mapGetters } from "vuex";
import { MoreVerticalIcon } from "@/assets/svgs";

export default {
  components: {
    BusinessMemberPrescription,
    BusinessMemberPrescriptionCreatePlan,
    BusinessMemberPrescriptionInviteToPlan,
    MoreVerticalIcon,
  },
  props: {
    businessId: String,
    userId: String,
    businessPrescriptionId: String,
  },
  data() {
    return {
      isLoading: false,
      prescriptions: [],
      showDeleted: false,
      rxItems: [],
      businessUsers: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  created() {
    this.EventBus.$on("prescription-created", this.loadPrescriptions);
    this.loadPrescriptions();
    this.getRxItems();
    this.loadBusinessLocations();
  },
  methods: {
    async loadPrescriptions() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.organization.id}/members/${this.userId}/prescriptions?showDeleted=${this.showDeleted}`);

        if (this.businessPrescriptionId) {
          this.prescriptions = response.data.filter((n) => n.id === this.businessPrescriptionId).sort((a, b) => a.businessProgram.name.localeCompare(b.businessProgram.name));
        } else {
          this.prescriptions = response.data.sort((a, b) => a.businessProgram.name.localeCompare(b.businessProgram.name));
        }
      } finally {
        this.isLoading = false;
      }
    },

    async getRxItems() {
      try {
        const url = `/businesses/${this.businessId}/item-categories/all`;
        this.$axios.get(url).then((res) => {
          this.rxItems = res.data.filter((i) => i.type === "rx_item" && i.status === "active" && i.isDeleted === false);
        });
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Unable to retrieve Rx Items",
          message: "We were not able to retrieve your Rx Items. There may have been a connection error. Please reload the page to try again.",
          error,
        });
      }
    },
    goToMemberPlans() {
      this.loadPrescriptions();
      this.$router.push(`/businesses/${this.organization.id}/members/${this.userId}/plans`);
    },
    async loadBusinessLocations() {
      this.$axios.get(`/businesses/${this.businessId}/locations/all`).then((res) => {
        this.businessUsers = res.data;
      });
    },
    handleUpdateSupervisingPrescriber({ prescriptionId, locationId }) {
      // Find and update prescription immutably
      this.prescriptions = this.prescriptions.map((presc) => {
        if (presc.id === prescriptionId) {
          return { ...presc, supervisingPrescriberId: locationId };
        }
        return presc;
      });
    },
  },
  watch: {
    userId() {
      this.loadPrescriptions();
    },
    showDeleted() {
      this.loadPrescriptions();
    },
  },
};
</script>
